import { compose, insert, remove } from 'ramda'

export const replaceOrAdd = (list, item, index) => {
  if (list.length > index && index >= 0) {
    return replace(list, item, index)
  }
  return [...list, item]
}

export const replace = (list, item, index) => {
  return compose(
    insert(index, item), //
    remove(index, 1)
  )(list)
}

export const isAllEqual = (list = []) => list.every(item => item === list[0])
